import React,{useEffect,useState,useRef} from "react";
import QRCode from "react-qr-code";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent,DialogUtility } from '@syncfusion/ej2-react-popups';

import { staffData, staffGrid,staffLevel,staffEdit,staffAdd,staffDelete } from "../data/staff";
import { Header } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import validator from "validator";


const QRMenu = () => {
  const { currentMode } = useStateContext();
  const bgcolor = currentMode === "Dark" ? "bg-gray-700" : "bg-white";


    return(
      <div className={"mx-5 rounded-2xl " + bgcolor} >
      <Header title="QR Menu" /> 
      
       <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-8 text-center">
          <QRCode
          size={256}
          style={{ height: "100px", width: "100px", margin: "0 auto" }}
          value={"https://www.startechuk.com"}
          viewBox={`0 0 256 256`}
        />
        <br />
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">QR Menu Builder</h3>
          <p className="text-gray-600 dark:text-gray-400">Its not ready yet....</p>
        </div>

    </div>
    )
  }
  
  export default QRMenu;
  